// Test IDs for the LIF landing page. Naming: <feature>-<element>, kebab-case.

export const HOME = {
        emergentLink: 'home-emergent-link',
        heroSection: 'hero-section',
        heroTitle: 'hero-title',
        heroTagline: 'hero-tagline',
        heroCta: 'hero-cta',
        videoBlock: 'video-block',
        videoPlayer: 'video-player',
        marquee: 'marquee',
        waitlistSection: 'waitlist-section',
        waitlistNomeInput: 'waitlist-nome-input',
        waitlistCognomeInput: 'waitlist-cognome-input',
        waitlistEmailInput: 'waitlist-email-input',
        waitlistTelefonoInput: 'waitlist-telefono-input',
        waitlistReferralInput: 'waitlist-referral-input',
        waitlistSubmit: 'waitlist-submit',
        successReferralCode: 'success-referral-code',
        courseSection: 'course-section',
        courseTitle: 'course-title',
        coursePriceFull: 'course-price-full',
        coursePriceDiscount: 'course-price-discount',
        coursePriceInstallments: 'course-price-installments',
        courseSubscription: 'course-subscription',
        courseCta: 'course-cta',
        courseAvailability: 'course-availability',
        sessionsSection: 'sessions-section',
        sessionMorning: 'session-morning',
        sessionOneToOne: 'session-one-to-one',
        shareWhatsapp: 'share-whatsapp',
        shareTelegram: 'share-telegram',
        shareEmail: 'share-email',
        shareFacebook: 'share-facebook',
        shareX: 'share-x',
        shareCopy: 'share-copy',
        waitlistSuccess: 'waitlist-success',
        waitlistError: 'waitlist-error',
        waitlistCount: 'waitlist-count',
        profileToggleStudente: 'profile-toggle-studente',
        profileToggleInvestitore: 'profile-toggle-investitore',
        navLogo: 'nav-logo',
        navCta: 'nav-cta',
        footer: 'site-footer',
        eventSection: 'event-section',
        eventDate: 'event-date',
        eventVenue: 'event-venue',
        eventCta: 'event-cta',
        audioToggle: 'audio-toggle',
        videoPlayButton: 'video-play-button',
};
